import React, { useState } from 'react';
import { Heart, Calendar, CheckCircle2, Star, ShieldCheck } from 'lucide-react';

export const AnimalTherapyModule: React.FC = () => {
  const [pets, setPets] = useState([
    { name: 'Buddy (Golden Retriever)', type: 'Certified Therapy Dog', status: 'Available', anxietyScore: '-42% Stress' },
    { name: 'Luna (Ragdoll Cat)', type: 'Calming Feline', status: 'On Session', anxietyScore: '-35% Stress' }
  ]);

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-rose-500/20 text-rose-300 text-xs font-bold rounded-full border border-rose-500/30">
            <Heart className="w-3.5 h-3.5" /> Module 23: Animal-Assisted Therapy (AAT) & Pet Care
          </div>
          <h2 className="text-2xl font-black mt-2">Therapy Animal Scheduling & Stress Reduction Tracker</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {pets.map((p, idx) => (
          <div key={idx} className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-slate-200">{p.name}</span>
              <span className="text-[10px] font-bold px-2 py-0.5 bg-emerald-500/20 text-emerald-300 rounded">
                {p.anxietyScore}
              </span>
            </div>
            <div className="text-xs text-slate-400">{p.type}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
